{
  "type": "object",
  "name": "ProduktionsauftragQuery",
  "class": "g gap gtc-1 gtc-m-2 gr-2 gr-m-3",
  "definitions": [
    {
      "type": "date",
      "class": "gc-1 gr-1",
      "name": "von_datum",
      "title": "Von Datum",
      "required": true
    },
    {
      "type": "date",
      "class": "gc-1 gr-2 gc-m-2 gr-m-1",
      "name": "bis_datum",
      "title": "Bis Datum",
      "required": true
    },
    {
      "type": "select",
      "class": "gc-1 gr-3 gc-m-1 gr-m-2",
      "name": "produktionsstatus",
      "title": "Produktionsstatus",
      "required": false,
      "control": "dropdown",
      "options": [
        {
          "value": "O",
          "title": "Offen"
        },
        {
          "value": "L",
          "title": "LLR"
        },
        {
          "value": "V",
          "title": "Vorbereitet"
        },
        {
          "value": "P",
          "title": "Produktion"
        },
        {
          "value": "E",
          "title": "Erledigt"
        },
        {
          "value": "A",
          "title": "Abgebrochen"
        },
        {
          "value": "F",
          "title": "Fertig"
        }
      ]
    },
    {
      "type": "fieldOk",
      "class": "gc-1 gr-4 gc-m-2 gr-m-2",
      "name": "kunde",
      "title": "Kunde",
      "required": false,
      "fieldOk": "ktostamm.kunde",
      "showQuery": false,
      "autoLoad": true,
      "format": "{{nummer}} - {{kurzbez}}",
      "inputMinLength": 2,
      "views": [
        {
          "type": "list",
          "title": "Kunden",
          "virtual": {
            "itemHeight": 94,
            "display": {
              "default": 4,
              "small": 5
            }
          },
          "definition": {
            "type": "object",
            "name": "",
            "class": "g gc-6 gr-4 border-box flex-nowrap truncate",
            "definitions": [
              {
                "type": "text",
                "class": "gr-1-1 gc-1-6 flex flex-row justify-start items-center flex-nowrap pl-2 pr-2 soft-overline border-box",
                "name": "nummer"
              },
              {
                "type": "text",
                "class": "gr-2-2 gc-1-6 flex flex-row justify-start items-center flex-nowrap soft-title pl-2 pr-2 truncate border-box",
                "name": "5"
              },
              {
                "type": "text",
                "class": "gr-3-3 gc-1-6 pl-2 pr-2 flex flex-row justify-start items-center flex-nowrap truncate border-box",
                "name": "13"
              },
              {
                "type": "text",
                "class": "gr-4-4 gc-1-5 pl-2 pr-2 flex flex-row justify-start items-center flex-nowrap color-light truncate border-box",
                "name": "15"
              },
              {
                "type": "text",
                "class": "gr-4-4 gc-6-6 flex flex-row justify-end items-center flex-nowrap pr-2 color-light truncate border-box",
                "name": "14"
              }
            ]
          }
        }
      ]
    },
    {
      "type": "fieldOk",
      "class": "gc-1 gr-5 gc-m-1 gr-m-3",
      "name": "maschinenbean",
      "format": "{{maschinenr}}",
      "title": "Maschine",
      "required": false,
      "fieldOk": "maschine",
      "parameters": {
        "idbetrieb":  {
          "type": "storeReference",
          "feature": "authenticationContext",
          "getter": "data",
          "property": "idbetrieb"
        }
      },
      "showQuery": false,
      "autoLoad": true
    },
    {
      "type": "text",
      "class": "gc-1 gr-6 gc-m-2 gr-m-3",
      "placeholder": "Chargennummer",
      "name": "chargennummer",
      "title": "Chargennummer",
      "required": false
    }
  ]
}
